import styled from "@emotion/styled";

import {
  getNotificationDismissButtonStyles,
  getNotificationIconSizeStyles,
  getNotificationMessageSizeStyles,
  getNotificationMessageVariantStyles,
} from "./notification-styles";
import type {
  StyledDismissButtonProps,
  StyledIconProps,
  StyledNotificationMessageProps,
} from "./types";

export const StyledNotificationMessage = styled.div<StyledNotificationMessageProps>`
  display: ${({ $visible }) => ($visible ? "flex" : "none")};
  align-items: flex-start;
  border-radius: ${({ $styleProps }) => $styleProps?.borderRadius ?? "8px"};
  font-weight: ${({ $styleProps }) => $styleProps?.fontWeight ?? 400};
  font-size: ${({ $styleProps }) => $styleProps?.fontSize ?? "inherit"};
  padding: ${({ $styleProps }) => $styleProps?.padding ?? "0"};
  margin: ${({ $styleProps }) => $styleProps?.margin ?? "0"};
  position: relative;
  transition: all 0.2s ease-in-out;

  ${({ $size = "medium", $styleProps }) => {
    // If custom padding is provided, don't use default size styles
    if ($styleProps?.padding) return "";
    return getNotificationMessageSizeStyles($size);
  }}

  ${({ $variant = "info", $styleProps }) =>
    getNotificationMessageVariantStyles($variant, $styleProps)}

  /* Animation for showing/hiding */
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible }) =>
    $visible ? "translateY(0)" : "translateY(-8px)"};

  /* Fade out animation when dismissing */
  &.notification-dismissing {
    opacity: 0;
    transform: translateY(-8px);
  }
`;

export const StyledNotificationIcon = styled.div<StyledIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${({ $size = "medium", $styleProps }) =>
    getNotificationIconSizeStyles($size, $styleProps)}
`;

export const StyledNotificationContent = styled.div`
  flex: 1;
  min-width: 0; /* Prevents flex item from overflowing */
`;

export const StyledNotificationTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledNotificationText = styled.div`
  line-height: 1.5;
`;

export const StyledDismissButton = styled.button<StyledDismissButtonProps>`
  ${({ $size = "medium", $variant = "info" }) =>
    getNotificationDismissButtonStyles($size, $variant)}
`;

export const StyledNotificationContainer = styled.div`
  position: relative;
  width: 100%;
`;
